// Wagwright: private upload of the customer's pet photo (replaces Shopify's native file field, whose URL is public).
// 1. The photo is decoded and re-encoded as JPEG in the browser (canvas): EXIF metadata (GPS, device) is dropped and
//    the longest side is capped at 3000 px. 2. It is sent to the private store (Cloudflare Worker + KV).
// 3. Only the random reference goes into the Shopify order (line item property "_Photo ref", hidden from the customer by Shopify).
// Add to cart is blocked while the upload runs or when no photo was added.
(function () {
  "use strict";
  var MAX_SIDE = 3000;
  var MAX_INPUT = 25 * 1024 * 1024;
  var MIN_SIDE = 1000; // below this, warn that the photo may be too small for a crisp print

  function toJpeg(file) {
    return createImageBitmap(file, { imageOrientation: "from-image" }).then(function (bmp) {
      var k = Math.min(1, MAX_SIDE / Math.max(bmp.width, bmp.height));
      var c = document.createElement("canvas");
      c.width = Math.round(bmp.width * k);
      c.height = Math.round(bmp.height * k);
      c.getContext("2d").drawImage(bmp, 0, 0, c.width, c.height);
      if (bmp.close) bmp.close();
      return new Promise(function (ok, ko) {
        c.toBlob(function (b) { b ? ok(b) : ko(new Error("encode")); }, "image/jpeg", 0.88);
      });
    });
  }

  function init(root) {
    if (root.dataset.wwReady) return;
    root.dataset.wwReady = "1";
    var input = root.querySelector("[data-ww-file]");
    var ref = root.querySelector("[data-ww-ref]");
    var status = root.querySelector("[data-ww-status]");
    var thumb = root.querySelector("[data-ww-thumb]");
    var url = root.getAttribute("data-upload-url");
    var formId = ref.getAttribute("form");
    var busy = false;
    // Placement preview: the customer's photo on drawn mug/ornament mockups, with the pet name and style.
    var prev = root.querySelector("[data-ww-prev]");
    var nameInput = root.querySelector('[name="properties[Pet name]"]');
    var styleSelect = root.querySelector('[name="properties[Portrait style]"]');

    function showPreview(src) {
      if (!prev) return;
      prev.querySelectorAll("[data-ww-prev-img]").forEach(function (img) { img.src = src; });
      prev.hidden = !src;
    }
    function syncName() {
      if (!prev || !nameInput) return;
      var v = nameInput.value.trim() || "Your pet";
      prev.querySelectorAll("[data-ww-prev-name]").forEach(function (el) { el.textContent = v; });
    }
    function syncStyle() {
      if (!prev || !styleSelect) return;
      prev.className = "ww-prev ww-prev--" + styleSelect.value.toLowerCase();
    }
    if (nameInput) nameInput.addEventListener("input", syncName);
    if (styleSelect) styleSelect.addEventListener("change", syncStyle);
    syncName();
    syncStyle();

    function say(msg, bad) {
      status.textContent = msg;
      root.classList.toggle("ww-perso--error", !!bad);
    }

    input.addEventListener("change", function () {
      var f = input.files && input.files[0];
      ref.value = "";
      if (thumb) { thumb.hidden = true; thumb.removeAttribute("src"); }
      showPreview("");
      if (!f) return;
      if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(f.type) || f.size > MAX_INPUT) {
        say(root.dataset.msgType, true); input.value = ""; return;
      }
      busy = true; say(root.dataset.msgUploading, false);
      var small = false;
      toJpeg(f)
        .then(function (blob) {
          // Small photos still upload (we check every photo before printing), but we say so now
          if (!window.createImageBitmap) return blob;
          return createImageBitmap(blob).then(function (bmp) {
            small = Math.min(bmp.width, bmp.height) < MIN_SIDE;
            if (bmp.close) bmp.close();
            return blob;
          }, function () { return blob; });
        })
        .then(function (blob) {
          var src = URL.createObjectURL(blob);
          if (thumb) { thumb.src = src; thumb.hidden = false; }
          showPreview(src);
          return fetch(url, { method: "POST", headers: { "Content-Type": "image/jpeg" }, body: blob });
        })
        .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); })
        .then(function (j) {
          if (!j.id) throw new Error("no id");
          ref.value = j.id;
          say(small ? root.dataset.msgSmall : root.dataset.msgDone, false);
        })
        .catch(function () {
          input.value = "";
          if (thumb) thumb.hidden = true;
          showPreview("");
          say(root.dataset.msgFailed, true);
        })
        .then(function () { busy = false; });
    });

    // Capture phase on window: runs before Horizon's delegated handlers, which listen on document in capture phase.
    window.addEventListener("submit", function (e) {
      // getAttribute: the product form has an <input name="id">, which shadows form.id
      if (!e.target || !e.target.getAttribute || e.target.getAttribute("id") !== formId) return;
      if (busy || !ref.value) {
        e.preventDefault();
        e.stopImmediatePropagation();
        say(busy ? root.dataset.msgWait : root.dataset.msgMissing, true);
        root.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      // A double click sent two submits and put 2 sets (159.90 $) in the cart. Ignore a repeat while the
      // add is pending and for 2.5 s after it succeeded; a failed add releases the guard so a retry goes through.
      var now = Date.now();
      if (adding.pending && now - adding.since > PENDING_MAX) {
        // No answer after 10 s: the first add may still reach the server, so it is not a failure. Cancel it (a
        // request still stuck in the browser then never arrives), then read the real cart before letting a retry
        // through: a line with this photo means the first add landed, and a retry would make it 2 sets.
        e.preventDefault();
        e.stopImmediatePropagation();
        if (adding.checking) return;
        adding.checking = true;
        if (adding.abort) adding.abort.abort();
        var form = e.target, photo = ref.value, routes = (window.Theme && window.Theme.routes) || {};
        var cartUrl = routes.cart_url || "/cart";
        (nativeFetch || window.fetch)(cartUrl + ".js", { headers: { Accept: "application/json" }, cache: "no-store" })
          .then(function (r) { if (!r.ok) throw new Error("cart " + r.status); return r.json(); })
          .then(function (cart) {
            var inCart = (cart.items || []).some(function (it) {
              return it.properties && it.properties["_Photo ref"] === photo;
            });
            adding.pending = false;
            if (inCart) {
              adding.okAt = Date.now();
              say(root.dataset.msgInCart, false);
              setTimeout(function () { window.location.assign(cartUrl); }, 1200);
            } else if (form.requestSubmit) {
              form.requestSubmit();
            } else {
              say(root.dataset.msgRetry, true);
            }
          }, function () {
            // Cart unreadable: keep blocking; the next click reads it again.
            say(root.dataset.msgUnsure, true);
          })
          .then(function () { adding.checking = false; });
        return;
      }
      if (adding.pending || now - adding.okAt < AFTER_OK) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      adding.pending = true;
      adding.since = now;
    }, true);
  }

  // Add-to-cart guard state, settled by the theme's own /cart/add request (watched through fetch)
  var AFTER_OK = 2500;
  var PENDING_MAX = 10000; // after this, a new click checks the real cart (/cart.js) before any retry
  var adding = { pending: false, since: 0, okAt: 0, checking: false, abort: null };
  if (window.fetch && !window.fetch.wwWrapped) {
    var nativeFetch = window.fetch;
    var wrapped = function (input, opts) {
      var u = typeof input === "string" ? input : (input && input.url) || "";
      if (u.indexOf("/cart/add") === -1) return nativeFetch.apply(this, arguments);
      var ctl = window.AbortController && typeof input === "string" && !(opts && opts.signal) ? new AbortController() : null;
      adding.abort = ctl;
      var p = ctl ? nativeFetch.call(this, input, Object.assign({}, opts, { signal: ctl.signal })) : nativeFetch.apply(this, arguments);
      return p.then(function (r) {
        adding.pending = false;
        if (r.ok) adding.okAt = Date.now();
        return r;
      }, function (err) {
        adding.pending = false;
        throw err;
      });
    };
    wrapped.wwWrapped = true;
    window.fetch = wrapped;
  }

  function boot() { document.querySelectorAll("[data-ww-perso]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
